export function getStylePropertyValue(element: HTMLDivElement, propertyName: string) {
  return getComputedStyle(element).getPropertyValue(propertyName);
}
